export enum LogLevel {
  ALL = 0xffff,
  NONE = 0x00,
  INFO = 0x01,
  VERBOSE = 0x02,
  WARNING = 0x04,
  ERROR = 0x08,
}

const loglevel = LogLevel.ALL;

export function log(level: LogLevel, ...optionalParams: any[]): void {
  if (process.env.REACT_APP_LOG == "1" && level & loglevel) {
    console.log(LogLevel[level], ...optionalParams);
  }
}
